// Tạo theme từ config API
export const createThemeFromConfig = (config) => {
  return {
    name: config.chat_title || 'Chat',
    colors: {
      primary: config.bubble_color || '#336699',
      background: '#ffffff',
      secondaryBackground: '#f8f9fa',
      headerBackground: config.chat_header_background_color || '#336699',
      text: config.chat_header_text_color || '#FFFFFF',
      secondaryText: '#6c757d',
      userMessageBackground: config.user_reply_background_color || '#336699',
      userMessageText: config.user_reply_text_color || '#FFFFFF',
      botMessageBackground: config.chatbot_reply_background_color || '#336699',
      botMessageText: config.chatbot_reply_text_color || '#FFFFFF',
      inputBackground: '#ffffff',
      inputText: '#212529',
      border: '#dee2e6'
    },
    borderRadius: {
      message: '16px',
      input: '16px',
      button: '12px'
    },
    fontSize: {
      small: '12px',
      base: '14px',
      large: '16px',
      header: '18px'
    },
    spacing: {
      unit: '8px'
    }
  };
};

// Export default theme cho trường hợp chưa load được config
export const defaultTheme = createThemeFromConfig({
  chat_title: 'Chat',
  bubble_color: '#336699',
  chat_header_background_color: '#336699',
  chat_header_text_color: '#FFFFFF',
  user_reply_background_color: '#336699',
  user_reply_text_color: '#FFFFFF',
  chatbot_reply_background_color: '#336699',
  chatbot_reply_text_color: '#FFFFFF'
});